import React from 'react';

function HomeError(props) {
    return (
        <div className="home-error">
            <h1 className="error-condition">{props.condition}</h1>
            <div className="error-description">
                <p>
                    {props.description}
                </p>
            </div>
        </div>
    );
}

export default HomeError;